import { AsyncStatus, defaultInitialState, State } from 'hooks/useAsync';
import PipedriveService, {
  PipedriveVerifyIntegrationResult,
} from './PipedriveService';
import { useCallback, useState } from 'react';

const useVerifyPipedriveIntegration = () => {
  const [{ error, isLoading, data, status }, setState] =
    useState<State<PipedriveVerifyIntegrationResult>>(defaultInitialState);

  const verifyPipedriveIntegration = useCallback(async () => {
    setState({
      error: null,
      status: AsyncStatus.pending,
      data: null,
      isLoading: true,
    });
    const resultPromise = PipedriveService.verifyPipedriveIntegration();
    resultPromise.then(
      (result) => {
        setState({
          error: null,
          status: AsyncStatus.resolved,
          data: result,
          isLoading: false,
        });
      },
      (error) => {
        setState({
          error: error,
          status: AsyncStatus.rejected,
          data: null,
          isLoading: false,
        });
      },
    );
  }, [setState]);

  return {
    verifyPipedriveIntegration,
    error,
    isLoading,
    isError:
      status === AsyncStatus.rejected ||
      (data?.data ? !data?.data.isSuccess : false),
    isSuccess: status === AsyncStatus.resolved && data?.data.isSuccess,
    data,
  };
};

export default useVerifyPipedriveIntegration;
